import { getParameters, getUserContext, nextStepCredStepper, removeQueryFromUrlWithoutReloadV2 } from "../../configs/utils";
import { Platform } from 'react-native';
import { QUERY_PARAMS } from "../../configs/constants";
import { api } from "../../configs/api";
import { getAuthHeaders } from "../../configs/config";
import { ROUTE } from "../../routes";
import { InputStateToken } from "@voltmoney/schema";
import SharedPropsService from "../../SharedPropsService";
export const onLoad = async ({ standardUtilities }) => {
    const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : '';
    const sl_id = params[QUERY_PARAMS.SL];
    const response = await standardUtilities.network.get(`${api.mfdSharelinkCustomerDetails}${sl_id}`, {
        headers: await getAuthHeaders(),
        handleFromMF: true,
    });
    if (response?.status === 200) {
        await standardUtilities.setDatastore(ROUTE.MFD_SHARE_LINK_INIT, 'mfdShareLinkPage', {
            details: response?.data
        });
    }
    else {
        if (response.response.data.voltErrorCode === "LINK_EXPIRED"
            || response.response.data.voltErrorCode === "INVALID_APPLICATION_STEP") {
            await standardUtilities.setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                linkExpired: true,
                counter: Math.random(),
                showOtpModal: false,
            });
        }
    }
};
export const initAction = async (action, _datastore, { network, setDatastore }) => {
    console.warn(" *** initAction action *** ", action);
    const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : '';
    const sl_id = params[QUERY_PARAMS.SL];
    const response = await network.get(`${api.mfdShareLinkInit}${sl_id}`, {
        headers: await getAuthHeaders(),
        handleFromMF: true,
    });
    if (response?.status === 200) {
        await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, 'mfdShareLinkPage', {
            initActionData: response?.data,
            showOtpModal: true,
            counter: Math.random()
        });
    }
    else {
        if (response.response.data.voltErrorCode === "LINK_EXPIRED"
            || response.response.data.voltErrorCode === "INVALID_APPLICATION_STEP") {
            //ADDED THE RESET CODE
            await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                linkExpired: false,
                counter: Math.random(),
                showOtpModal: true,
            });
            // ------------------- //
            await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                linkExpired: true,
                counter: Math.random(),
                showOtpModal: false,
            });
        }
        if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                otpState: InputStateToken.DISABLED,
                caption: { error: response.response.data.message },
                otpLimitExceeded: true,
                showOtpModal: true,
                counter: Math.random()
            });
        }
        else {
            await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                otpState: InputStateToken.ERROR,
                showOtpModal: true,
                caption: { error: response.response.data.message },
                counter: Math.random()
            });
        }
    }
};
export const verifyAction = async (action, _datastore, { network, setDatastore, navigateToBase }) => {
    console.warn(" *** verifyAction action *** ", action);
    const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : '';
    const sl_id = params[QUERY_PARAMS.SL];
    const stepId = action?.payload?.stepId;
    const response = await network.post(`${api.mfdShareLinkVerify}`, {
        otp: action?.payload?.requestValue,
        shortUrl: sl_id
    }, {
        headers: await getAuthHeaders(),
        handleFromMF: true,
    });
    if (response?.status === 200) {
        await SharedPropsService.setToken(response?.data?.jwt);
        const user = await getUserContext(network, { overrideCache: true });
        Platform.OS === 'web' && removeQueryFromUrlWithoutReloadV2(`${[QUERY_PARAMS.SL]}`);
        if (user?.linkedApplications[0]?.currentStepId !== stepId) {
            await navigateToBase(ROUTE.MFD_SHARE_LINK_INIT, { showEndJourney: true });
        }
        else {
            const routeObj = await nextStepCredStepper(user?.linkedApplications[0]?.currentStepId);
            await navigateToBase(routeObj.routeId, routeObj.params);
        }
    }
    else {
        if (response.response.data.voltErrorCode === "LINK_EXPIRED"
            || response.response.data.voltErrorCode === "INVALID_APPLICATION_STEP") {
            await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                linkExpired: true,
                counter: Math.random(),
                showOtpModal: false,
            });
        }
        if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                otpState: InputStateToken.DISABLED,
                caption: { error: response.response.data.message },
                otpLimitExceeded: true,
                showOtpModal: true,
                counter: Math.random()
            });
        }
        else {
            await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, "mfdShareLinkPage", {
                otpState: InputStateToken.ERROR,
                showOtpModal: true,
                caption: { error: response.response.data.message },
                counter: Math.random()
            });
        }
    }
};
export const handleCloseOtpModalAction = async (action, _datastore, { setDatastore }) => {
    console.warn(" *** handleCloseOtpModalAction action *** ", action);
    await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, 'mfdShareLinkPage', {
        initActionData: null,
        showOtpModal: false,
        otpState: InputStateToken.DEFAULT,
        counter: Math.random()
    });
};
// handleTextChangeOtpAction
export const handleTextChangeOtpAction = async (action, _datastore, { setDatastore }) => {
    console.warn(" *** handleTextChangeOtpAction action *** ", action);
    await setDatastore(ROUTE.MFD_SHARE_LINK_INIT, 'mfdShareLinkPage', {
        otpState: InputStateToken.DEFAULT,
        caption: null,
        counter: Math.random()
    });
};
export const navNextToStepper = async (action, _datastore, { navigateWithClear }) => {
    console.warn(" *** navNext action *** ", action);
    await navigateWithClear(ROUTE.KYC_STEPPER);
};
